"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineMathFloater = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const PositionAtPoint_1 = require("@jsonjoy.com/ui/lib/utils/popup/PositionAtPoint");
const useClickAway_1 = require("@jsonjoy.com/ui/lib/hooks/useClickAway");
const context_1 = require("../context");
const InlineMathPopup_1 = require("./InlineMathPopup");
const InlineMathFloater = () => {
    const mutxt = (0, context_1.useMuTxt)();
    const state = mutxt.inline.math;
    const open = state.open.use();
    const point = state.point.use();
    const clickAwayRef = (0, useClickAway_1.useClickAway)(React.useCallback(() => state.close(), [state]));
    if (!open || !point)
        return null;
    return (React.createElement(PositionAtPoint_1.PositionAtPoint, { point: point, animate: true },
        React.createElement("div", { ref: clickAwayRef, onMouseDown: (e) => {
                // Allow focus on input-like fields inside the popup. Suppress the
                // default mousedown elsewhere so the surrounding editor doesn't
                // pull focus back to itself.
                const target = e.target;
                const tag = target.tagName;
                if (tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'MATH-FIELD') {
                    e.preventDefault();
                }
                e.stopPropagation();
            }, onKeyDown: (e) => {
                if (e.key === 'Escape') {
                    e.stopPropagation();
                    e.preventDefault();
                    state.close();
                }
            } },
            React.createElement(InlineMathPopup_1.InlineMathPopup, { state: state }))));
};
exports.InlineMathFloater = InlineMathFloater;
